import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialXOutlineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.8014 3.5H20.867L14.136 10.714L22 20.5H15.8287L10.997 14.5531L5.46551 20.5H2.39987L9.53082 12.7841L2 3.5H8.32456L12.6898 8.93247L17.8014 3.5ZM16.7284 18.8063H18.4279L7.43152 5.131H5.60546L16.7284 18.8063Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
